import { library } from '@fortawesome/fontawesome-svg-core';

import { faDesktop, faEnvelope, faMobile, faShoppingCart, faSearch, faComments, faCoffee, faPlay } from '@fortawesome/free-solid-svg-icons';

library.add(faDesktop, faEnvelope, faMobile, faShoppingCart, faSearch, faComments, faCoffee, faPlay);
